/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InactivateJudgmentDto
 */
export interface InactivateJudgmentDto {
    /**
     * Set when the judgment must first be cancelled in P1: the cancellation document to sign
     * @type {string}
     * @memberof InactivateJudgmentDto
     */
    cancellationDocumentId: string | null;
}

/**
 * Check if a given object implements the InactivateJudgmentDto interface.
 */
export function instanceOfInactivateJudgmentDto(value: object): value is InactivateJudgmentDto {
    if (!('cancellationDocumentId' in value) || value['cancellationDocumentId'] === undefined) return false;
    return true;
}

export function InactivateJudgmentDtoFromJSON(json: any): InactivateJudgmentDto {
    return InactivateJudgmentDtoFromJSONTyped(json, false);
}

export function InactivateJudgmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InactivateJudgmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cancellationDocumentId': json['cancellationDocumentId'],
    };
}

export function InactivateJudgmentDtoToJSON(value?: InactivateJudgmentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cancellationDocumentId': value['cancellationDocumentId'],
    };
}

